import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { PagedResult, ProjectListItemDto, QueryOptions } from '../lib/types';

export interface ProjectsQueryOptions extends QueryOptions {
  /** Saved-filter selection — union semantics with each other. */
  personIds?: number[];
  projectIds?: number[];
}

export function useProjects(options: ProjectsQueryOptions) {
  const params = new URLSearchParams();
  if (options.page) params.set('page', String(options.page));
  if (options.pageSize) params.set('pageSize', String(options.pageSize));
  if (options.sortBy) params.set('sortBy', options.sortBy);
  if (options.sortDesc != null) params.set('sortDesc', String(options.sortDesc));
  if (options.filter) params.set('filter', options.filter);
  for (const id of options.personIds ?? []) params.append('personIds', String(id));
  for (const id of options.projectIds ?? []) params.append('projectIds', String(id));

  return useQuery({
    queryKey: ['projects', options],
    queryFn: () => apiClient.get<PagedResult<ProjectListItemDto>>(`/api/projects?${params}`),
  });
}
